/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_Timing_SettingsInputs */

const en_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update timing settings`)
};

const fr_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour les paramètres de minutage`)
};

const de_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeiteinstellungen aktualisieren`)
};

const it_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna le impostazioni di temporizzazione`)
};

const ru_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить настройки времени`)
};

const es_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar la configuración de tiempo`)
};

const zh_cn2_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新时间设置`)
};

const ja_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミング設定を更新する`)
};

const hi_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय सेटिंग्स अपडेट करें`)
};

const pt_pt2_update_timing_settings = /** @type {(inputs: Update_Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar configurações de tempo`)
};

/**
* | output |
* | --- |
* | "Update timing settings" |
*
* @param {Update_Timing_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_timing_settings = /** @type {((inputs?: Update_Timing_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_Timing_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_timing_settings(inputs)
	if (locale === "de") return de_update_timing_settings(inputs)
	if (locale === "it") return it_update_timing_settings(inputs)
	if (locale === "ru") return ru_update_timing_settings(inputs)
	if (locale === "es") return es_update_timing_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_update_timing_settings(inputs)
	if (locale === "ja") return ja_update_timing_settings(inputs)
	if (locale === "hi") return hi_update_timing_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_update_timing_settings(inputs)
	return en_update_timing_settings(inputs)
});